import ListItem, {ListItemProps} from "@material-ui/core/ListItem"
import React from "react"
import {Link, LinkProps} from "react-router-dom"

export const ListItemLink = (props: ListItemProps & LinkProps) => (
    // @ts-ignore
    <ListItem button={true} component={Link} {...props}/>
)
